<app-delete-verification-modal></app-delete-verification-modal>
<app-application-environment-message></app-application-environment-message>
<lib-notification></lib-notification>

<ng-template [ngIf]="fileDeleting">
  <div class="browser-page__loader browser-page__file-delete-loader">
    <lib-loader>Deleting File. Please wait ...</lib-loader>
  </div>
</ng-template>

<ng-template [ngIf]="parentNodesLoading">
  <div class="browser-page__loader browser-page__parent-folder-loader">
    <lib-loader>Loading parent folders. Please wait ...</lib-loader>
  </div>
</ng-template>

<ng-template [ngIf]="loadingChildNodes">
  <div class="browser-page__loader browser-page__parent-folder-loader">
    <lib-loader>Loading files. Please wait ...</lib-loader>
  </div>
</ng-template>

<div class="browse-page__container">
  <app-browse-sidebar
    *ngIf="browseSidebarOpen"
    [nodes]="parentNodes"
    [selectedNode]="selectedFolder"
    [nodesLoading]="parentNodesLoading"
    (closeIconClick)="onCloseIcon()"
    (selectedNodeChange)="onFolderSelect($event)"
  ></app-browse-sidebar>

  <div class="browse-page__container-body">
    <app-top-panel
      [username]="userSettings?.username"
      [browseSidebarOpen]="browseSidebarOpen"
      [(userCornerPopupOpen)]="userCornerPopupOpen"
      (browseSidebarOpenChange)="browseSidebarOpenChange($event)"
      (userSettingsSelect)="onUserSettingsSelect()"
    ></app-top-panel>

    <div *ngIf="files" class="browse-page__body">
      <div *ngIf="selectedFolder?.label" class="browse-page__body-table-header">
        <i class="fa fa-university browse-page__body-table-header-icon" aria-hidden="true"></i>
        <span class="browse-page__body-table-header-divider">/</span>
        <span class="browse-page__body-table-header-text">{{ locationLabel }}</span>
      </div>

      <ng-container [ngSwitch]="browseContentMode">
        <ng-container
          *ngSwitchCase="browseContentModes.BrowseTable"
          [ngTemplateOutlet]="browseTableTemplate"
        ></ng-container>
        <ng-container
          *ngSwitchCase="browseContentModes.UserSettings"
          [ngTemplateOutlet]="userSettingsTemplate"
        ></ng-container>
      </ng-container>

      <ng-template #browseTableTemplate>
        <app-browse-table
          [parentNode]="selectedFolder"
          [readOnly]="isUserHasReadOnlyAccessToFolder()"
          [downloadFiles]="downloadFiles"
          (downloadFile)="onDownloadFile($event)"
          (filesBatchDownload)="onFilesBatchDownload($event)"
          (uploadFile)="onUploadFile()"
          (deleteFile)="onDeleteFile($event)"
        >
        </app-browse-table>
      </ng-template>

      <ng-template #userSettingsTemplate>
        <app-settings> </app-settings>
      </ng-template>
    </div>
  </div>
</div>
